export class Filter {
    Property: string;
    Operation: string;
    Values: (string | null)[];

    constructor(Property: string, Operation: string, Values: (string | null)[]) {
        this.Property = Property;
        this.Operation = Operation;
        this.Values = Values;
    }
}

export class SearchQuery {
    Filters: Filter[];

    constructor(Filters: Filter[]) {
        this.Filters = Filters;
    }
}